export const PerPage = {
  4: '4',
  8: '8',
  16: '16',
  all: 'all',
};
